import React from "react";

interface SelectionCardProps {
    title: string;
    description?: string;
    selected: boolean;
    onClick: () => void;
}

const SelectionCard: React.FC<SelectionCardProps> = ({
    title,
    description,
    selected,
    onClick,
}) => {
    return (
        <label
            className="relative flex items-center cursor-pointer min-h-[54px] w-full"
            onClick={onClick}
        >
            {/* Hidden Input for accessibility/semantics */}
            <input
                type="radio"
                className="absolute inset-0 opacity-0"
                checked={selected}
                onChange={onClick}
                readOnly
            />

            {/* Background & Border */}
            <div
                className={`absolute inset-0 border-2 rounded-lg transition-all duration-200 ${selected
                    ? "border-purple-500 bg-purple-50/50"
                    : "border-gray-300 bg-transparent"
                    }`}
            ></div>

            {/* Content Container */}
            <div className="relative flex items-center gap-4 px-6 py-2 z-0 pointer-events-none w-full">

                {/* Custom Radio Circle */}
                <div className="w-7 h-7 rounded-full border-2 border-purple-500 flex-shrink-0 flex items-center justify-center">
                    {/* Inner Filled Dot */}
                    <div
                        className={`w-5 h-5 bg-purple-500 rounded-full transition-opacity duration-200 ${selected ? "opacity-100" : "opacity-0"
                            }`}
                    ></div>
                </div>

                {/* Text Content */}
                <div className="flex flex-col">
                    <span className="text-black text-[18px] py-3 font-medium">{title}</span>
                    {description && (
                        <span className="text-sm text-gray-400 mt-1">
                            {description}
                        </span>
                    )}
                </div>

            </div>
        </label>
    );
};

export default SelectionCard;